import React from 'react';
import { ButtonMinorAction } from '../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

type CollapsibleExpanderButtonBarProps = {
  collapseAllOnClick: () => void;
  collapseAllButtonDisabled: boolean;
  expandAllOnClick: () => void;
  expandAllButtonDisabled: boolean;
  ariaControls: string;
};

export function CollapsibleExpanderButtonBar({
  collapseAllOnClick,
  collapseAllButtonDisabled,
  expandAllOnClick,
  expandAllButtonDisabled,
  ariaControls,
}: CollapsibleExpanderButtonBarProps) {
  const { t } = useSonTranslation('phrases');

  return (
    <div className="collapsible-expander">
      <div className="collapsible-expander__button-container">
        <ButtonMinorAction
          icon={Icons.CLOSE_ALL}
          text={t('collapseAllElements')}
          tooltipPlacement={TooltipPlacement.TOP}
          ariaDisabled={collapseAllButtonDisabled}
          ariaControls={ariaControls}
          onClick={collapseAllOnClick}
        />
      </div>
      <div className="collapsible-expander__button-container">
        <ButtonMinorAction
          icon={Icons.OPEN_ALL}
          text={t('expandAllElements')}
          tooltipPlacement={TooltipPlacement.TOP}
          ariaDisabled={expandAllButtonDisabled}
          ariaControls={ariaControls}
          onClick={expandAllOnClick}
        />
      </div>
    </div>
  );
}
